import classes from '../index.module.scss'
import { Cancel } from './Cancel'
import { Reset } from './Reset'
import { Save } from './Save'

export const ButtonGroup = ({ createMode, onCancel, onSave }) => {
  return (
    <div className={classes.footer}>
      <Cancel onCancel={onCancel} />
      <Reset createMode={createMode} />
      <Save createMode={createMode} onSave={onSave} />
    </div>
  )
}
